"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getListaFromUri = getListaFromUri;
exports.getPageFromUri = getPageFromUri;
exports.getTypeOfPageFromUri = getTypeOfPageFromUri;
exports.getImmotype = getImmotype;
exports.getImmotypeLK = getImmotypeLK;
exports.getLicenseTypeGroups = getLicenseTypeGroups;
exports.getImmotypeSlug = getImmotypeSlug;
exports.checkHomonymousRegion = checkHomonymousRegion;
exports.decodeGeo = decodeGeo;
exports.decodeGeoType = decodeGeoType;
exports.decodeAree = decodeAree;
exports.getBuildingConditions = getBuildingConditions;
exports.getRooms = getRooms;
exports.getPrice = getPrice;
exports.getFeatures = getFeatures;
exports.getPublisher = getPublisher;
exports.dumpImmotype = dumpImmotype;
exports.getImmotypeSlugLangFromKey = getImmotypeSlugLangFromKey;
exports.getChildrenImmotypeSlugFromKeys = getChildrenImmotypeSlugFromKeys;
exports.getChildrenImmotypeFromKeys = getChildrenImmotypeFromKeys;
exports.getSubImmotypeSlugLangFromKey = getSubImmotypeSlugLangFromKey;
exports.getLicenseTypeGroupFromKey = getLicenseTypeGroupFromKey;
exports.getLicenseTypeGroupSlugFromKey = getLicenseTypeGroupSlugFromKey;
exports.getSeoDataFromJson = getSeoDataFromJson;
exports.getHashKeyFromSlugAndLevel = exports.checkParamsFromMyCasa = exports.convertFeaturesMyCasaToFilters = exports.isDictionary = exports.getStrCategoryImmotype = exports.getObjByCategoryImmotype = exports.findImmotypes = exports.getCategoryImmotype = exports.HELPER_MANAGER_TYPE = exports.PROVINCES_BY_SHORT = exports.PRECISION_FROM_ZOOM_CONF = exports.PTYPES_TO_ENCODE_DIFFERENTLY = exports.PTYPES_FOR_LICENSE_TYPE_GROUPS_SEOURL = exports.LICENSE_TYPE_CUSTOM_SLUGS_TRANSLATIONS = exports.LICENSE_TYPES_TO_EXCLUDE_FROM_SEO_URL = exports.LICENSE_TYPE_GROUPS_PLURAL = exports.LICENSE_TYPE_GROUPS_DECODE = exports.BUILDING_CONDITION_ENCODE = exports.BUILDING_CONDITION_DECODE = exports.PROPERTY_TYPES_GENDER = exports.PROPERTY_TYPES_SINGULAR = exports.PROPERTY_TYPES_PLURAL_EXCEPTIONS = exports.PROPERTY_TYPES_PLURAL = exports.PUBLISHER_TYPE_ENCODE = exports.ROOMS_DECODE = exports.ROOMS_ENCODE = exports.PROPERTY_TYPES_TO_EXCLUDE_FROM_SEO_URL = exports.PROPERTY_TYPES_GROUP_UNIQUE = exports.PROPERTY_TYPES_GROUP_KEYS = exports.PROPERTY_TYPES_TERRENI = exports.PROPERTY_TYPES_GROUP = exports.CAT_ENCODE = exports.TR_ENCODE = exports.RE_ENCODE = exports.DECODE_PROPERTYTYPEGROUP_SEO_URL = exports.CAT_DECODE_FOR_ESAPI = exports.PUB_DECODE_FOR_ESAPI = exports.TR_DECODE_FOR_ESAPI = exports.TR_DECODE = exports.WEBSITE_DEFAULT_LANG = exports.DOUBLE_FILTERS_LIST_FOR_REDIRECT_SEO = exports.FEATURES_VALID_FOR_RESIDENTIAL_ONLY = exports.WHITELIST_FILTERS_SEO_TO_SRP_URL = exports.PUBLISHER_LABELS = exports.GEO_TYPE_CITY = exports.GEO_TYPE_PROVINCE = exports.GEO_TYPE_REGION = exports.GEO_TYPE_AREAGROUP = exports.DEFAULT_IMMOTYPE = exports.DEFAULT_PROPERTYTYPEGROUP = exports.DEFAULT_CATEGORY = exports.DEFAULT_LANG = exports.REGEXP_FINISH_WITH_NUMBERS = exports.REGEXP_ATLEAST_ONE_LETTER = exports.REGEXP_PUBLISHER_NAME_AND_LOC = exports.REGEXP_PUBLISHER_NAME = exports.REGEXP_PUBLISHER_LOC = exports.REGEXP_PUBLISHER_OK = exports.REGEXP_PUBLISHER_REDIRECT = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _ImmoTypeHelper = require("./ImmoTypeHelper");

var _homonymoustowns = _interopRequireDefault(require("./homonymoustowns.json"));

var _homonymousprovinces = _interopRequireDefault(require("./homonymousprovinces.json"));

var _homonymousregions = _interopRequireDefault(require("./homonymousregions.json"));

var _slugify = require("../helpers/slugify");

var _slugify2 = require("./slugify");

var _helpers = require("../utils/helpers");

var _MiddlewareRedirectHelper = require("./MiddlewareRedirectHelper");

var _it;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var REGEXP_REGIONS = new RegExp(/(^abruzzo$|^basilicata$|^calabria$|^campania$|^emilia-romagna$|^friuli-venezia-giulia$|^lazio$|^liguria$|^lombardia$|^marche$|^molise$|^piemonte$|^puglia$|^sardegna$|^sicilia$|^toscana$|^trentino-alto-adige$|^umbria$|^valle-d-aosta$|^provence-alpes-cote-azur$|^veneto$)/gi);
var REGEXP_PROVINCE = new RegExp(/([a-zA-z-+]*)-(provincia)$/g);
var REGEXP_TURISM_ZONE = new RegExp(/(^area)-([0-9])-([0-9a-zA-z-+]*)$/g);
var REGEXP_DEFAULT_AREA = new RegExp(/^([0-9a-zA-z-+]*)$/g);
var REGEXP_METRO_LINE = new RegExp(/(^metro)-([0-9a-zA-z-+]*)$/g);
var REGEXP_ROOMS = new RegExp(/(\d*)-\b(local[ei])\b/g);
var REGEXP_DROOMS = new RegExp(/\b(monolocal[ei]?|bilocal[ei]?|trilocal[ei]?|quadrilocal[ei])\b/g);
var REGEXP_PRICE = new RegExp(/(^prezzo)-(da|finoa)-([0-9]*)$/g);
var REGEXP_PRICEFULL = new RegExp(/(^prezzo)-((da)-([0-9]{1,})-(finoa))-([0-9]*)$/g);
var REGEXP_PUBLISHER = new RegExp(/(^da)-(agenzie?|costruttori?|privati)$/g);
/**
 * 
 * AIUTOOOOOO
 * 
 */
// const REGEXP_FEATURES = new RegExp(/^(con-)([a-zA-z-+0-9]*)$/g);

var REGEXP_FEATURES = new RegExp(/^(con-|da-)(?!agenzie|costruttori|privati)([a-zA-z-+0-9]*)$/g);
/**
 * 
 * AIUTOOOOOO
 * 
 */

var REGEXP_BUILDING_CONDITIONS = new RegExp(/^(in-nuove-costruzioni|nuove-costruzioni|da-ristrutturare)$/g);
var REGEXP_VACATION = new RegExp(/(^vacanza)-([a-zA-z-+0-9]*)$/g);
var REGEXP_COMMERCIAL = new RegExp(/(^commerciale)-([a-zA-z-+0-9]*)$/g);
var REGEXP_HOMONYMOUS_TOWN = new RegExp(/^([a-zA-Z-]*)-(\w{2})$/g);
var REGEXP_GARDEN_TYPE = new RegExp(/^giardino[+-](comune|privato)$/gi);
var REGEXP_HEATIG_TYPE = new RegExp(/^riscaldamento[+-](autonomo|centralizzato)$/gi);
var REGEXP_LIFT_LEVEL = new RegExp(/^ascensore-se-almeno-([1-5])-piano$/gi);
var REGEXP_BOX = new RegExp(/box[+-]post([oi])[+-]auto?|post([oi])[+-]auto?|box$/gi);
var REGEXP_PUBLISHER_LEVEL = new RegExp(/^da[+-](agenzie|privati|costruttori)$/gi);
var REGEXP_PUBLISHER_REDIRECT = new RegExp(/da-\d+\/lista-/g);
exports.REGEXP_PUBLISHER_REDIRECT = REGEXP_PUBLISHER_REDIRECT;
var REGEXP_PUBLISHER_OK = new RegExp(/da-\d+\/\w+/g);
exports.REGEXP_PUBLISHER_OK = REGEXP_PUBLISHER_OK;
var REGEXP_PUBLISHER_LOC = new RegExp(/^(in-.*)/g);
exports.REGEXP_PUBLISHER_LOC = REGEXP_PUBLISHER_LOC;
var REGEXP_PUBLISHER_NAME = new RegExp(/^(e-.*)/g);
exports.REGEXP_PUBLISHER_NAME = REGEXP_PUBLISHER_NAME;
var REGEXP_PUBLISHER_NAME_AND_LOC = new RegExp(/^(e-.*)-(in-.*)/g);
exports.REGEXP_PUBLISHER_NAME_AND_LOC = REGEXP_PUBLISHER_NAME_AND_LOC;
var REGEXP_ATLEAST_ONE_LETTER = new RegExp(/^(.*[a-z|A-Z]+.*)/g);
exports.REGEXP_ATLEAST_ONE_LETTER = REGEXP_ATLEAST_ONE_LETTER;
var REGEXP_FINISH_WITH_NUMBERS = new RegExp(/-[0-9]+$/g);
exports.REGEXP_FINISH_WITH_NUMBERS = REGEXP_FINISH_WITH_NUMBERS;
var DEFAULT_LANG = 'it';
exports.DEFAULT_LANG = DEFAULT_LANG;
var DEFAULT_CATEGORY = 'residenziale';
exports.DEFAULT_CATEGORY = DEFAULT_CATEGORY;
var DEFAULT_PROPERTYTYPEGROUP = 'case';
exports.DEFAULT_PROPERTYTYPEGROUP = DEFAULT_PROPERTYTYPEGROUP;
var DEFAULT_IMMOTYPE = 'tutte';
exports.DEFAULT_IMMOTYPE = DEFAULT_IMMOTYPE;
var GEO_TYPE_AREAGROUP = 'areagroup';
exports.GEO_TYPE_AREAGROUP = GEO_TYPE_AREAGROUP;
var GEO_TYPE_REGION = 'region';
exports.GEO_TYPE_REGION = GEO_TYPE_REGION;
var GEO_TYPE_PROVINCE = 'province';
exports.GEO_TYPE_PROVINCE = GEO_TYPE_PROVINCE;
var GEO_TYPE_CITY = 'city';
exports.GEO_TYPE_CITY = GEO_TYPE_CITY;
var PUBLISHER_LABELS = ['da-agenzie', 'da-costruttori', 'da-privati'];
exports.PUBLISHER_LABELS = PUBLISHER_LABELS;
var WHITELIST_FILTERS_SEO_TO_SRP_URL = ["air_conditioned", "availability", "balcony", "buildingCondition", "buildingYearMax", "buildingYearMin", "energyClass", "only_auction", "exclude_auction", "exclude_private_negotiation", "only_private_negotiation", "exclude_under_construction", "is_lux", "furniture", "has_reception", "has_swimming_pool", "has_virtual_tour", "heatingType", "level", "lift", "mqMax", "mqMin", "numBaths", "numParkingSpaces", "photo", "priceMax", "priceMin", "publication_date", "sellerType", "terrace", 'commercial_building_location', 'includes_property_ownership'];
exports.WHITELIST_FILTERS_SEO_TO_SRP_URL = WHITELIST_FILTERS_SEO_TO_SRP_URL;
var FEATURES_VALID_FOR_RESIDENTIAL_ONLY = ["availability", "only_auction", "has_swimming_pool"];
exports.FEATURES_VALID_FOR_RESIDENTIAL_ONLY = FEATURES_VALID_FOR_RESIDENTIAL_ONLY;
var DOUBLE_FILTERS_LIST_FOR_REDIRECT_SEO = ['balcony', 'heating', 'heatingType', 'lift', 'numParkingSpaces', 'sellerType', 'terrace', 'garden'];
exports.DOUBLE_FILTERS_LIST_FOR_REDIRECT_SEO = DOUBLE_FILTERS_LIST_FOR_REDIRECT_SEO;
var WEBSITE_DEFAULT_LANG = {
  'athome.lu': 'fr',
  'athome.de': 'de',
  'immoregion.fr': 'fr',
  'casa.it': 'it',
  'attico.it': 'it'
};
exports.WEBSITE_DEFAULT_LANG = WEBSITE_DEFAULT_LANG;
var TR_DECODE = {
  en: {
    buy: 'buy',
    rent: 'rent'
  },
  fr: {
    vente: 'buy',
    location: 'rent'
  },
  de: {
    kaufen: 'buy',
    mieten: 'rent'
  },
  it: {
    vendita: 'buy',
    affitti: 'rent',
    affitto: 'rent'
  }
};
exports.TR_DECODE = TR_DECODE;
var TR_DECODE_FOR_ESAPI = {
  it: {
    buy: 'vendita',
    rent: 'affitti',
    vendita: 'vendita',
    affitti: 'affitti',
    affitto: 'affitti'
  }
};
exports.TR_DECODE_FOR_ESAPI = TR_DECODE_FOR_ESAPI;
var PUB_DECODE_FOR_ESAPI = {
  it: {
    agenzie: 'agenzie'
  }
};
exports.PUB_DECODE_FOR_ESAPI = PUB_DECODE_FOR_ESAPI;
var CAT_DECODE_FOR_ESAPI = {
  it: {
    residenziale: 'residenziale',
    "case": 'case',
    'case-vacanza': 'case-vacanza',
    commerciale: 'commerciale',
    vacanze: 'vacanze',
    vacanza: 'vacanze',
    terreni: 'terreni',
    'cantine-solai': 'cantine-solai',
    'cantine+solai': 'cantine-solai',
    'garage-posti-auto': 'garage-posti-auto',
    'garage+posti+auto': 'garage-posti-auto',
    stanze: 'stanze',

    /* TECH-7860 - TRASPASOS */
    uffici: 'uffici',
    capannoni: 'capannoni',
    'edifici-palazzi': 'edifici-palazzi'
    /* TECH-7860 - TRASPASOS */

  }
};
exports.CAT_DECODE_FOR_ESAPI = CAT_DECODE_FOR_ESAPI;
var DECODE_PROPERTYTYPEGROUP_SEO_URL = {
  it: {
    'residenziale': 'case',
    'vacanze': 'case-vacanza'
  }
};
exports.DECODE_PROPERTYTYPEGROUP_SEO_URL = DECODE_PROPERTYTYPEGROUP_SEO_URL;
var RE_ENCODE = {
  en: {
    'real-estate': 'real-estate'
  },
  fr: {
    'real-estate': 'immobilier'
  },
  de: {
    'real-estate': 'immobilien'
  },
  it: {
    'real-estate': 'realestate'
  }
};
exports.RE_ENCODE = RE_ENCODE;
var TR_ENCODE = {
  en: {
    buy: 'buy',
    rent: 'rent'
  },
  fr: {
    buy: 'vente',
    rent: 'location'
  },
  de: {
    buy: 'kaufen',
    rent: 'mieten'
  },
  it: {
    buy: 'vendita',
    rent: 'affitto',
    vendita: 'vendita',
    affitti: 'affitto',
    affitto: 'affitto'
  }
};
exports.TR_ENCODE = TR_ENCODE;
var CAT_ENCODE = {
  it: (_it = {
    residenziale: 'residenziale',
    "case": 'residenziale',
    commerciale: 'commerciale',
    vacanze: 'vacanza'
  }, _defineProperty(_it, "vacanze", 'vacanza'), _defineProperty(_it, 'case-vacanza', 'vacanza'), _defineProperty(_it, "terreni", 'terreni'), _defineProperty(_it, "residential", 'residenziale'), _defineProperty(_it, 'project-profile', 'nuova-costruzione'), _defineProperty(_it, 'nuova-costruzione', 'nuova-costruzione'), _defineProperty(_it, "commercial", 'commerciale'), _defineProperty(_it, "holiday", 'vacanza'), _defineProperty(_it, 'cantine-solai', 'cantine-solai'), _defineProperty(_it, 'garage-posti-auto', 'garage-posti-auto'), _defineProperty(_it, 'stanze', 'stanze'), _defineProperty(_it, "uffici", 'uffici'), _defineProperty(_it, "capannoni", 'capannoni'), _defineProperty(_it, 'edifici-palazzi', 'edifici-palazzi'), _it)
};
exports.CAT_ENCODE = CAT_ENCODE;
var PROPERTY_TYPES_GROUP = {
  it: {
    residenziale: 'residenziale',
    commerciale: 'commerciale',
    vacanze: 'vacanza',
    vacanza: 'vacanza',
    terreni: 'terreni',
    residential: 'residenziale',
    'project-profile': 'nuova-costruzione',
    'nuova-costruzione': 'nuova-costruzione',
    commercial: 'commerciale',
    holiday: 'vacanza',
    'garage-posto-auto': 'garage-posto-auto',
    'garage+posto+auto': 'garage-posto-auto',
    'garage-posti-auto': 'garage-posto-auto',
    'garage+posti+auto': 'garage-posto-auto',
    'cantina-solaio': 'cantina-solaio',
    'cantina+solaio': 'cantina-solaio',
    'cantine-solai': 'cantina-solaio',
    'cantine+solai': 'cantina-solaio',
    'stanze': 'stanze',

    /* TECH-7860 - TRASPASOS */
    uffici: 'uffici',
    capannoni: 'capannoni',
    'edifici-palazzi': 'edifici-palazzi',
    'edifici+palazzi': 'edifici+palazzi'
    /* TECH-7860 - TRASPASOS */

  }
};
/* DECODE BOTH SRP AND PDP */

exports.PROPERTY_TYPES_GROUP = PROPERTY_TYPES_GROUP;
var PROPERTY_TYPES_TERRENI = ['terreni-edificabili', 'terreni-industriali', 'terreni-agricoli', 'terreno-edificabile', 'terreno-industriale', 'terreno-agricolo',
/**** */
'terreno+edificabile', 'terreno+agricolo', 'terreno+industriale'];
exports.PROPERTY_TYPES_TERRENI = PROPERTY_TYPES_TERRENI;
var PROPERTY_TYPES_GROUP_KEYS = {
  it: ['case', 'case-vacanza', 'commerciale', 'cantine-solai', 'terreni', 'garage-posti-auto', 'stanze',
  /* TECH-7860 - TRASPASOS */
  'uffici', 'capannoni', 'edifici-palazzi'
  /* TECH-7860 - TRASPASOS */
  ]
};
exports.PROPERTY_TYPES_GROUP_KEYS = PROPERTY_TYPES_GROUP_KEYS;
var PROPERTY_TYPES_GROUP_UNIQUE = {
  'garage-posto-auto': 'garage-posto-auto',
  'garage+posto+auto': 'garage-posto-auto',
  'garage-posti-auto': 'garage-posto-auto',
  'garage+posti+auto': 'garage-posto-auto',
  'cantina-solaio': 'cantina-solaio',
  'cantina+solaio': 'cantina-solaio',
  'cantine-solai': 'cantina-solaio',
  'cantine+solai': 'cantina-solaio',
  'stanze': 'stanze',

  /* TECH-7860 - TRASPASOS */
  uffici: 'uffici',
  capannoni: 'capannoni',
  'edifici-palazzi': 'edifici-palazzi'
  /* TECH-7860 - TRASPASOS */

};
exports.PROPERTY_TYPES_GROUP_UNIQUE = PROPERTY_TYPES_GROUP_UNIQUE;
var PROPERTY_TYPES_TO_EXCLUDE_FROM_SEO_URL = {
  it: {
    residenziale: ['baite-bungalow-chalet-trulli', 'immobili-di-prestigio', 'palazzi', 'porzioni-di-case', 'terratetto-terracielo'],
    "case": ['baite-bungalow-chalet-trulli', 'immobili-di-prestigio', 'palazzi', 'porzioni-di-case', 'terratetto-terracielo'],
    commerciale: ['show-room', 'stabili-palazzi', 'aziende-agricole'
    /* TECH-7860 - TRASPASOS */
    // 'locali-commerciali',
    // 'attivita-licenze-commerciali',

    /* TECH-7860 - TRASPASOS */
    ],
    vacanze: ['attici-mansarde', 'baite-bungalow-chalet-trulli', 'loft', 'rustici-casali', 'case-bifamiliari-trifamiliari'],
    'case-vacanza': ['attici-mansarde', 'baite-bungalow-chalet-trulli', 'loft', 'rustici-casali', 'case-bifamiliari-trifamiliari'],
    'cantine-solai': ['cantine-solai']
  }
};
exports.PROPERTY_TYPES_TO_EXCLUDE_FROM_SEO_URL = PROPERTY_TYPES_TO_EXCLUDE_FROM_SEO_URL;
var ROOMS_ENCODE = {
  1: 'monolocali',
  2: 'bilocali',
  3: 'trilocali',
  4: 'quadrilocali'
};
exports.ROOMS_ENCODE = ROOMS_ENCODE;
var ROOMS_DECODE = {
  monolocale: 1,
  monolocali: 1,
  bilocale: 2,
  bilocali: 2,
  trilocale: 3,
  trilocali: 3,
  quadrilocale: 4,
  quadrilocali: 4
};
exports.ROOMS_DECODE = ROOMS_DECODE;
var PUBLISHER_TYPE_ENCODE = {
  it: {
    agency: {
      label: 'agenzia',
      plural: 'agenzie'
    },
    developer: {
      label: 'costruttore',
      plural: 'costruttori'
    },
    "private": {
      label: 'privato',
      plural: 'privati'
    }
  }
};
exports.PUBLISHER_TYPE_ENCODE = PUBLISHER_TYPE_ENCODE;
var PROPERTY_TYPES_PLURAL = {
  appartamento: 'Appartamenti',
  attico: 'Attici',
  'baita+chalet+trullo': 'Baite, chalet, trulli',
  'baita+bungalow+chalet+trullo': 'Baite, bungalow, chalet, trulli',
  bungalow: 'Bungalow',
  'cantina+solaio': 'Cantine, solai',
  'cantina-solaio': 'Cantine, solai',
  'casa+bi+trifamiliare': 'Case bifamiliari, trifamiliari',
  'casa+indipendente': 'Case indipendenti',
  'garage+box+auto': 'Garage, box auto',
  'garage+posto+auto': 'Garage, posti auto',
  'garage-posto-auto': 'Garage, posti auto',
  'imobile+di+prestigio': 'Immobili di prestigio',
  'immobile+di+prestigio': 'Immobili di prestigio',
  loft: 'Loft',
  mansarda: 'Mansarde',
  monolocale: 'Monolocali',
  'nuova+costruzione': 'Nuove costruzioni',
  palazzo: 'Palazzi',
  'porzione+di+casa': 'Porzioni di case',
  'rustico+casale': 'Rustici, casali',
  terreno: 'Terreni',
  'terreno+edificabile': 'Terreni edificabili',
  villa: 'Ville',
  'villetta+a+schiera': 'Villette a schiera',
  albergo: 'Alberghi',
  'azienda+agricola': 'Aziende agricole',
  bar: 'Bar',
  capannone: 'Capannoni',
  'cessione+di+azienda': 'Cessione di azienda',
  'garage+auto+silos': 'Garage, auto silos',
  laboratorio: 'Laboratori',
  'locale+commerciale': 'Locali commerciali',
  'negozio+locale+commerciale': 'Negozi, locali commerciali',
  'negozio-locale-commerciale': 'Negozi, locali commerciali',
  magazzino: 'Magazzini',
  negozio: 'Negozi',
  resort: 'Resort',
  ristorante: 'Ristoranti',
  'show+room': 'Show room',
  'stabile+palazzo': 'Stabili, palazzi',
  stanza: 'Stanze',
  'terreno+agricolo': 'Terreni agricoli',
  'terreno+industriale': 'Terreni industriali',
  ufficio: 'Uffici',
  'ufficio+di+rappresentanza': 'Uffici di rappresentanza',
  'attico-mansarda': 'Attici, Mansarde',
  'attico+mansarda': 'Attici, Mansarde',

  /* TECH-7860 - TRASPASOS */
  'immobile+commerciale': 'Immobili commerciali',
  'immobile+con+attivita+commerciale': 'Immobili con attività commerciali',
  'attivita+licenza+commerciale': 'Attività, licenze commerciali',
  'attivita-licenza-commerciale': 'Attività, licenze commerciali'
};
exports.PROPERTY_TYPES_PLURAL = PROPERTY_TYPES_PLURAL;
var PROPERTY_TYPES_PLURAL_EXCEPTIONS = {
  'attivita+licenza+commerciale': 'Attività commerciali',
  'negozio+locale+commerciale': 'Locali commerciali'
};
exports.PROPERTY_TYPES_PLURAL_EXCEPTIONS = PROPERTY_TYPES_PLURAL_EXCEPTIONS;
var PROPERTY_TYPES_SINGULAR = {
  appartamento: 'Appartamento',
  albergo: 'Albergo',
  attico: 'Attico',
  'attico+mansarda': 'Attico, mansarda',
  'attico-mansarda': 'Attico, mansarda',
  'attivita+licenza+commerciale': 'Attività, licenza commerciale',
  'attivita-licenza-commerciale': 'Attività, licenza commerciale',
  'attivita-licenza-(con-o-senza-mura)': 'Attività, licenza commerciale',
  'azienda+agricola': 'Azienda agricola',
  'azienda-agricola': 'Azienda agricola',
  'baita+chalet+trullo': 'Baita, chalet, trullo',
  'baita-chalet-trullo': 'Baita, chalet, trullo',
  'baita+bungalow+chalet+trullo': 'Baita, bungalow, chalet, trullo',
  'baita-bungalow-chalet-trullo': 'Baita, bungalow, chalet, trullo',
  bar: 'Bar',
  bungalow: 'Bungalow',
  capannone: 'Capannone',
  'cessione+di+azienda': 'Cessione di azienda',
  'cessione-di-azienda': 'Cessione di azienda',
  'cantina+solaio': 'Cantina, solaio',
  'cantina-solaio': 'Cantina, solaio',
  'casa+bi+trifamiliare': 'Casa bifamiliare, trifamiliare',
  'casa-bi-trifamiliare': 'Casa bifamiliare, trifamiliare',
  'casa+indipendente': 'Casa indipendente',
  'casa-indipendente': 'Casa indipendente',
  'garage+box+auto': 'Garage, box auto',
  'garage-box-auto': 'Garage, box auto',
  'garage-posto-auto': 'Garage, posto auto',
  'garage+posto+auto': 'Garage, posto auto',
  'imobile+di+prestigio': 'Immobile di prestigio',
  'immobile+di+prestigio': 'Immobile di prestigio',
  'immobile-di-prestigio': 'Immobile di prestigio',
  loft: 'Loft',
  mansarda: 'Mansarda',
  monolocale: 'Monolocale',
  'nuova+costruzione': 'Nuova costruzione',
  'nuova-costruzione': 'Nuova costruzione',
  palazzo: 'Palazzo',
  'porzione+di+casa': 'Porzione di casa',
  'porzione-di-casa': 'Porzione di casa',
  'rustico+casale': 'Rustico, casale',
  'rustico-casale': 'Rustico, casale',
  terreno: 'Terreno',
  'terreno+edificabile': 'Terreno edificabile',
  'terreno-edificabile': 'Terreno edificabile',
  villa: 'Villa',
  'villetta+a+schiera': 'Villetta a schiera',
  'villetta-a-schiera': 'Villetta a schiera',
  'garage+auto+silos': 'Garage, auto silos',
  'garage-auto-silos': 'Garage, auto silos',
  laboratorio: 'Laboratorio',
  'locale+commerciale': 'Locale commerciale',
  'locale-commerciale': 'Locale commerciale',
  'negozio+locale+commerciale': 'Locale commerciale',
  'negozio-locale-commerciale': 'Locale commerciale',
  magazzino: 'Magazzino',
  negozio: 'Negozio',
  resort: 'Resort',
  ristorante: 'Ristorante',
  'show+room': 'Show room',
  'show-room': 'Show room',
  'stabile+palazzo': 'Stabile, palazzo',
  'stabile-palazzo': 'Stabile, palazzo',
  stanza: 'Stanza',
  'terreno+agricolo': 'Terreno agricolo',
  'terreno-agricolo': 'Terreno agricolo',
  'terreno+industriale': 'Terreno industriale',
  'terreno-industriale': 'Terreno industriale',
  ufficio: 'Ufficio',
  'ufficio+di+rappresentanza': 'Ufficio di rappresentanza',
  'ufficio-di-rappresentanza': 'Ufficio di rappresentanza',
  edificio: 'Edificio'
};
exports.PROPERTY_TYPES_SINGULAR = PROPERTY_TYPES_SINGULAR;
var PROPERTY_TYPES_GENDER = {
  "case": 'f',
  appartamento: 'm',
  attico: 'm',
  'attico+mansarda': 'm',
  'attico-mansarda': 'm',
  'baita+chalet+trullo': 'm',
  'baita-chalet-trullo': 'm',
  'baita+bungalow+chalet+trullo': 'm',
  'baita-bungalow-chalet-trullo': 'm',
  bungalow: 'm',
  'casa+bi+trifamiliare': 'f',
  'casa-bi-trifamiliare': 'f',
  'casa+indipendente': 'f',
  'casa-indipendente': 'f',
  'imobile+di+prestigio': 'm',
  'immobile+di+prestigio': 'm',
  'immobile-di-prestigio': 'm',
  loft: 'm',
  palazzo: 'm',
  'porzione+di+casa': 'f',
  'porzione-di-casa': 'f',
  'rustico+casale': 'm',
  'rustico-casale': 'm',
  'terratetto-terracielo': 'm',
  villa: 'f',
  'villetta+a+schiera': 'f',
  'villetta-a-schiera': 'f'
};
exports.PROPERTY_TYPES_GENDER = PROPERTY_TYPES_GENDER;
var BUILDING_CONDITION_DECODE = {
  it: {
    'in-nuove-costruzioni': 'nuovo',
    'da-ristrutturare': 'da-ristrutturare',
    'nuova-costruzione': 'nuovo',
    'nuove-costruzioni': 'nuovo',
    nuovo: 'nuovo'
  }
};
exports.BUILDING_CONDITION_DECODE = BUILDING_CONDITION_DECODE;
var BUILDING_CONDITION_ENCODE = {
  it: {
    nuovo: {
      slug: 'in-nuove-costruzioni',
      label: 'Nuove costruzioni'
    },
    'da-ristrutturare': {
      slug: 'da-ristrutturare',
      label: 'Da Ristrutturare'
    }
  }
};
/* TECH-7860 - TRASPASOS */

exports.BUILDING_CONDITION_ENCODE = BUILDING_CONDITION_ENCODE;
var LICENSE_TYPE_GROUPS_DECODE = {
  'strutture-ricettive': 'struttura-ricettiva',
  'bar-pub-caffe': 'bar-pub-caffe',
  'ristorazione': 'ristorazione',
  'alimentari': 'alimentari',
  'tabaccherie': 'tabaccheria',
  'farmacie': 'farmacia',
  'edicole': 'edicola',
  'commercio-al-dettaglio': 'commercio-al-dettaglio',
  'centri-educativi': 'centro-educativo',
  'estetica-e-bellezza': 'estetica-e-bellezza',
  'palestre': 'palestre',
  'servizi-professionali': 'servizi-professionali',
  'laboratori': 'laboratorio',
  // 'magazzini': 'magazzino',
  'altre-attivita': 'altre-attivita',
  'negozi': 'negozio'
};
exports.LICENSE_TYPE_GROUPS_DECODE = LICENSE_TYPE_GROUPS_DECODE;
var LICENSE_TYPE_GROUPS_PLURAL = {
  'struttura-ricettiva': 'Strutture ricettive',
  'bar-pub-caffe': 'Bar, pub e caffè',
  ristorazione: 'Ristoranti e locali con cucina',
  tabaccheria: 'Tabaccherie',
  'alimentari': 'Negozi di alimentari',
  farmacia: 'Farmacie',
  edicola: 'Edicole',
  'commercio-al-dettaglio': 'Negozi di vendita al dettaglio',
  'centro-educativo': 'Centri educativi',
  'estetica-e-bellezza': 'Centri estetici e parrucchieri',
  'palestra': 'Palestre',
  'palestre': 'Palestre',
  'servizi-professionali': 'Servizi professionali',
  laboratorio: 'Laboratori',
  magazzino: 'Magazzini',
  'altre-attivita': 'Altre attività',
  'negozio': 'Negozi'
};
exports.LICENSE_TYPE_GROUPS_PLURAL = LICENSE_TYPE_GROUPS_PLURAL;
var LICENSE_TYPES_TO_EXCLUDE_FROM_SEO_URL = ['Centro educativo', 'Altre attività'];
exports.LICENSE_TYPES_TO_EXCLUDE_FROM_SEO_URL = LICENSE_TYPES_TO_EXCLUDE_FROM_SEO_URL;
var LICENSE_TYPE_CUSTOM_SLUGS_TRANSLATIONS = {
  'negozi-al-dettaglio': 'commercio-al-dettaglio',
  'cura-del-corpo': 'estetica-e-bellezza'
};
exports.LICENSE_TYPE_CUSTOM_SLUGS_TRANSLATIONS = LICENSE_TYPE_CUSTOM_SLUGS_TRANSLATIONS;
var PTYPES_FOR_LICENSE_TYPE_GROUPS_SEOURL = {
  'attivita-licenze-commerciali': ['strutture-ricettive', 'bar-pub-caffe', 'ristorazione', 'alimentari', 'tabaccherie', 'farmacie', 'edicole', 'commercio-al-dettaglio', 'estetica-e-bellezza', 'palestre', 'servizi-professionali', 'negozi'],
  'negozi-locali-commerciali': ['laboratori', 'magazzini']
};
/* TECH-7860 - TRASPASOS */

/**
 * TECH-4878
 * Some encode has to be calculated differently
 * if arrives negozi-locali-commerciali he has to be
 * handled like locale-commerciale because the SEO URL
 * is .../locali-commerciali/...
 */

exports.PTYPES_FOR_LICENSE_TYPE_GROUPS_SEOURL = PTYPES_FOR_LICENSE_TYPE_GROUPS_SEOURL;
var PTYPES_TO_ENCODE_DIFFERENTLY = {
  'Negozio/Locale commerciale': 'Locale commerciale',
  'negozio+locale+commerciale': 'Locale commerciale'
};
exports.PTYPES_TO_ENCODE_DIFFERENTLY = PTYPES_TO_ENCODE_DIFFERENTLY;
var PRECISION_FROM_ZOOM_CONF = {
  21: 8,
  20: 8,
  19: 8,
  18: 7,
  17: 7,
  16: 7,
  15: 6,
  14: 6,
  13: 6,
  12: 5,
  11: 5,
  10: 5,
  9: 4,
  8: 4,
  7: 3,
  6: 3,
  5: 3
};
exports.PRECISION_FROM_ZOOM_CONF = PRECISION_FROM_ZOOM_CONF;
var PROVINCES_BY_SHORT = {
  ag: {
    name: 'Agrigento',
    slug: 'agrigento'
  },
  al: {
    name: 'Alessandria',
    slug: 'alessandria'
  },
  an: {
    name: 'Ancona',
    slug: 'ancona'
  },
  ao: {
    name: 'Aosta',
    slug: 'aosta'
  },
  ap: {
    name: 'Ascoli piceno',
    slug: 'ascoli-piceno'
  },
  aq: {
    name: 'L aquila',
    slug: 'l-aquila'
  },
  ar: {
    name: 'Arezzo',
    slug: 'arezzo'
  },
  at: {
    name: 'Asti',
    slug: 'asti'
  },
  av: {
    name: 'Avellino',
    slug: 'avellino'
  },
  ba: {
    name: 'Bari',
    slug: 'bari'
  },
  bg: {
    name: 'Bergamo',
    slug: 'bergamo'
  },
  bi: {
    name: 'Biella',
    slug: 'biella'
  },
  bl: {
    name: 'Belluno',
    slug: 'belluno'
  },
  bn: {
    name: 'Benevento',
    slug: 'benevento'
  },
  bo: {
    name: 'Bologna',
    slug: 'bologna'
  },
  br: {
    name: 'Brindisi',
    slug: 'brindisi'
  },
  bs: {
    name: 'Brescia',
    slug: 'brescia'
  },
  bt: {
    name: 'Barletta andria trani',
    slug: 'barletta-andria-trani'
  },
  bz: {
    name: 'Bolzano',
    slug: 'bolzano'
  },
  ca: {
    name: 'Cagliari',
    slug: 'cagliari'
  },
  cb: {
    name: 'Campobasso',
    slug: 'campobasso'
  },
  ce: {
    name: 'Caserta',
    slug: 'caserta'
  },
  ch: {
    name: 'Chieti',
    slug: 'chieti'
  },
  ci: {
    name: 'Carbonia iglesias',
    slug: 'carbonia-iglesias'
  },
  cl: {
    name: 'Caltanissetta',
    slug: 'caltanissetta'
  },
  cn: {
    name: 'Cuneo',
    slug: 'cuneo'
  },
  co: {
    name: 'Como',
    slug: 'como'
  },
  cr: {
    name: 'Cremona',
    slug: 'cremona'
  },
  cs: {
    name: 'Cosenza',
    slug: 'cosenza'
  },
  ct: {
    name: 'Catania',
    slug: 'catania'
  },
  cz: {
    name: 'Catanzaro',
    slug: 'catanzaro'
  },
  en: {
    name: 'Enna',
    slug: 'enna'
  },
  fc: {
    name: 'Forli cesena',
    slug: 'forli-cesena'
  },
  fe: {
    name: 'Ferrara',
    slug: 'ferrara'
  },
  fg: {
    name: 'Foggia',
    slug: 'foggia'
  },
  fi: {
    name: 'Firenze',
    slug: 'firenze'
  },
  fm: {
    name: 'Fermo',
    slug: 'fermo'
  },
  fr: {
    name: 'Frosinone',
    slug: 'frosinone'
  },
  ge: {
    name: 'Genova',
    slug: 'genova'
  },
  go: {
    name: 'Gorizia',
    slug: 'gorizia'
  },
  gr: {
    name: 'Grosseto',
    slug: 'grosseto'
  },
  im: {
    name: 'Imperia',
    slug: 'imperia'
  },
  is: {
    name: 'Isernia',
    slug: 'isernia'
  },
  kr: {
    name: 'Crotone',
    slug: 'crotone'
  },
  lc: {
    name: 'Lecco',
    slug: 'lecco'
  },
  le: {
    name: 'Lecce',
    slug: 'lecce'
  },
  li: {
    name: 'Livorno',
    slug: 'livorno'
  },
  lo: {
    name: 'Lodi',
    slug: 'lodi'
  },
  lt: {
    name: 'Latina',
    slug: 'latina'
  },
  lu: {
    name: 'Lucca',
    slug: 'lucca'
  },
  mb: {
    name: 'Monza e brianza',
    slug: 'monza-e-brianza'
  },
  mc: {
    name: 'Macerata',
    slug: 'macerata'
  },
  me: {
    name: 'Messina',
    slug: 'messina'
  },
  mi: {
    name: 'Milano',
    slug: 'milano'
  },
  mn: {
    name: 'Mantova',
    slug: 'mantova'
  },
  mo: {
    name: 'Modena',
    slug: 'modena'
  },
  ms: {
    name: 'Massa carrara',
    slug: 'massa-carrara'
  },
  mt: {
    name: 'Matera',
    slug: 'matera'
  },
  na: {
    name: 'Napoli',
    slug: 'napoli'
  },
  no: {
    name: 'Novara',
    slug: 'novara'
  },
  nu: {
    name: 'Nuoro',
    slug: 'nuoro'
  },
  og: {
    name: 'Ogliastra',
    slug: 'ogliastra'
  },
  or: {
    name: 'Oristano',
    slug: 'oristano'
  },
  ot: {
    name: 'Olbia tempio',
    slug: 'olbia-tempio'
  },
  pa: {
    name: 'Palermo',
    slug: 'palermo'
  },
  pc: {
    name: 'Piacenza',
    slug: 'piacenza'
  },
  pd: {
    name: 'Padova',
    slug: 'padova'
  },
  pe: {
    name: 'Pescara',
    slug: 'pescara'
  },
  pg: {
    name: 'Perugia',
    slug: 'perugia'
  },
  pi: {
    name: 'Pisa',
    slug: 'pisa'
  },
  pn: {
    name: 'Pordenone',
    slug: 'pordenone'
  },
  po: {
    name: 'Prato',
    slug: 'prato'
  },
  pr: {
    name: 'Parma',
    slug: 'parma'
  },
  pt: {
    name: 'Pistoia',
    slug: 'pistoia'
  },
  pu: {
    name: 'Pesaro urbino',
    slug: 'pesaro-urbino'
  },
  pv: {
    name: 'Pavia',
    slug: 'pavia'
  },
  pz: {
    name: 'Potenza',
    slug: 'potenza'
  },
  ra: {
    name: 'Ravenna',
    slug: 'ravenna'
  },
  rc: {
    name: 'Reggio di calabria',
    slug: 'reggio-di-calabria'
  },
  re: {
    name: 'Reggio emilia',
    slug: 'reggio-emilia'
  },
  rg: {
    name: 'Ragusa',
    slug: 'ragusa'
  },
  ri: {
    name: 'Rieti',
    slug: 'rieti'
  },
  rm: {
    name: 'Roma',
    slug: 'roma'
  },
  rn: {
    name: 'Rimini',
    slug: 'rimini'
  },
  ro: {
    name: 'Rovigo',
    slug: 'rovigo'
  },
  sa: {
    name: 'Salerno',
    slug: 'salerno'
  },
  si: {
    name: 'Siena',
    slug: 'siena'
  },
  so: {
    name: 'Sondrio',
    slug: 'sondrio'
  },
  sp: {
    name: 'La spezia',
    slug: 'la-spezia'
  },
  sr: {
    name: 'Siracusa',
    slug: 'siracusa'
  },
  ss: {
    name: 'Sassari',
    slug: 'sassari'
  },
  su: {
    name: 'Sud sardegna',
    slug: 'sud-sardegna'
  },
  sv: {
    name: 'Savona',
    slug: 'savona'
  },
  ta: {
    name: 'Taranto',
    slug: 'taranto'
  },
  te: {
    name: 'Teramo',
    slug: 'teramo'
  },
  tn: {
    name: 'Trento',
    slug: 'trento'
  },
  to: {
    name: 'Torino',
    slug: 'torino'
  },
  tp: {
    name: 'Trapani',
    slug: 'trapani'
  },
  tr: {
    name: 'Terni',
    slug: 'terni'
  },
  ts: {
    name: 'Trieste',
    slug: 'trieste'
  },
  tv: {
    name: 'Treviso',
    slug: 'treviso'
  },
  ud: {
    name: 'Udine',
    slug: 'udine'
  },
  va: {
    name: 'Varese',
    slug: 'varese'
  },
  vb: {
    name: 'Verbano cusio ossola',
    slug: 'verbano-cusio-ossola'
  },
  vc: {
    name: 'Vercelli',
    slug: 'vercelli'
  },
  ve: {
    name: 'Venezia',
    slug: 'venezia'
  },
  vi: {
    name: 'Vicenza',
    slug: 'vicenza'
  },
  vr: {
    name: 'Verona',
    slug: 'verona'
  },
  vs: {
    name: 'Medio campidano',
    slug: 'medio-campidano'
  },
  vt: {
    name: 'Viterbo',
    slug: 'viterbo'
  },
  vv: {
    name: 'Vibo valentia',
    slug: 'vibo-valentia'
  },
  '01': {
    name: 'Alpes Maritimes',
    slug: 'alpes-maritimes'
  },
  '02': {
    name: 'Herault',
    slug: 'herault'
  },
  '03': {
    name: 'Alpes h Provence',
    slug: 'alpes-h-provence'
  },
  '04': {
    name: 'Haute Savoie',
    slug: 'haute-savoie'
  },
  '05': {
    name: 'Ain',
    slug: 'ain'
  },
  '06': {
    name: 'Corsica',
    slug: 'corsica'
  },
  '07': {
    name: 'Var',
    slug: 'var'
  },
  '60': {
    name: 'San Marino',
    slug: 'repubblica-di-san-marino'
  }
};
exports.PROVINCES_BY_SHORT = PROVINCES_BY_SHORT;
var IMMOTYPE_L = {
  it: {},
  de: {},
  en: {},
  fr: {}
};
var IMMOTYPE = (0, _ImmoTypeHelper.getImmotypeLang)(IMMOTYPE_L);
var IMMOTYPE_LK = {
  de: {},
  en: {},
  fr: {},
  it: {}
};
var IMMOTYPELK = (0, _ImmoTypeHelper.getImmotypeLangKey)(IMMOTYPE_LK);
var BUSINESS_L = {
  it: {},
  de: {},
  en: {},
  fr: {}
};
var BUSINESS = (0, _ImmoTypeHelper.getLicenseTypeGroupsLang)(BUSINESS_L);

function getListaFromUri(value) {
  try {
    var REGEXP_PAGE = /(lista)-(.*?)($)/g;
    var MATCH_PAGE = REGEXP_PAGE.exec(value);

    if (MATCH_PAGE) {
      var page = 1;

      if (MATCH_PAGE[2].indexOf('?') > -1) {
        page = MATCH_PAGE[2].split('?')[0];
      } else if (MATCH_PAGE[2].indexOf('&') > -1) {
        page = MATCH_PAGE[2].split('&')[0];
      } else {
        page = MATCH_PAGE[2];
      }

      return page;
    } else {
      return null;
    }
  } catch (error) {
    return null;
  }
}

function getPageFromUri(value) {
  try {
    var REGEXP_PAGE = /(page)=(.*?)($)/g;
    var MATCH_PAGE = REGEXP_PAGE.exec(value);

    if (MATCH_PAGE) {
      var page = 1;

      if (MATCH_PAGE[2].indexOf('?') > -1) {
        page = MATCH_PAGE[2].split('?')[0];
      } else if (MATCH_PAGE[2].indexOf('&') > -1) {
        page = MATCH_PAGE[2].split('&')[0];
      } else {
        page = MATCH_PAGE[2];
      }

      return page;
    } else {
      return null;
    }
  } catch (error) {
    return null;
  }
}

function getTypeOfPageFromUri(uri) {
  var lista = getListaFromUri(uri);
  var page = getPageFromUri(uri);
  return {
    lista: lista,
    page: page
  };
}

;
var HELPER_MANAGER_TYPE = {
  OLD: 'old-seo-url',
  RE: 'real-estate',
  IT: 'immotype',
  TR: 'transaction',
  AGSRP: 'agency-srp',
  PDP: 'listing-page',
  HUB: 'hub-page',
  PUB: 'publisher',
  APRO: 'agent-pro',
  ZNA: 'non-administrative-zones'
};
exports.HELPER_MANAGER_TYPE = HELPER_MANAGER_TYPE;

var getCategoryImmotype = function getCategoryImmotype(lang) {
  var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_IMMOTYPE;

  if (!value) {
    return {};
  }

  var category = DEFAULT_CATEGORY;
  var immotype = value;
  var len = 1;
  REGEXP_VACATION.lastIndex = 0;
  var match_vacation = REGEXP_VACATION.exec(value);

  if (match_vacation) {
    category = CAT_DECODE_FOR_ESAPI[lang][match_vacation[1]];
    immotype = match_vacation[2];
    len = 2;
  }

  REGEXP_COMMERCIAL.lastIndex = 0;
  var match_commercial = REGEXP_COMMERCIAL.exec(value);

  if (match_commercial) {
    category = CAT_DECODE_FOR_ESAPI[lang][match_commercial[1]];
    immotype = match_commercial[2];
    len = 2;
  }

  if (Object.keys(PROPERTY_TYPES_GROUP_UNIQUE).includes(value)) {
    category = value;
    immotype = value;
    len = 1;
  }
  /* exception for redirect vacanze-terreni*/


  if (PROPERTY_TYPES_TERRENI.includes(value)) {
    category = 'terreni';
    immotype = value;
  }
  /**
   * TECH-4878 locale-commerciale -> negozio+locale+commerciale decode
   */

  /* TECH-7860 
  if (value === 'locali-commerciali') {
    immotype = 'negozio-locale-commerciale';
    len = 1;
  }
  TECH-7860 */


  return {
    category: category,
    immotype: immotype,
    len: len
  };
};

exports.getCategoryImmotype = getCategoryImmotype;

var findImmotypes = function findImmotypes(lang, value) {
  var imt = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : getImmotype(lang);
  var itypes = [];
  Object.keys(imt).map(function (ckey) {
    Object.keys(imt[ckey].children).map(function (ikey) {
      if (imt[ckey].children[ikey].keys.includes(value)) {
        itypes.push(imt[ckey].children[ikey]);
      }
    });
  });
  return itypes;
};

exports.findImmotypes = findImmotypes;

var getObjByCategoryImmotype = function getObjByCategoryImmotype(lang) {
  var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_IMMOTYPE;

  if (!value) {
    return {};
  }

  var imt = getImmotype(lang);
  var cat = getCategoryImmotype(lang, value);
  var obj = null;
  var immotypes = findImmotypes(lang, cat.immotype, imt);

  if (cat.len === 1 && immotypes.length === 1) {
    return immotypes[0];
  } else {
    /* CASE PDP TITLE FOR CATEGORY WITHOUT PTYPES*/
    if (!imt[cat.category]) {
      cat.category = (0, _slugify2.slugify)((0, _helpers.getPluralPropertyType)(cat.category));
    }

    if (imt[cat.category] && imt[cat.category].children[cat.immotype]) {
      return imt[cat.category].children[cat.immotype];
    }

    if (imt[cat.category]) {
      Object.keys(imt[cat.category].children).map(function (k) {
        if (imt[cat.category].children[k].keys.includes(cat.immotype)) {
          obj = imt[cat.category].children[k];
        }
      });
    }
  }

  return obj;
};

exports.getObjByCategoryImmotype = getObjByCategoryImmotype;

var getStrCategoryImmotype = function getStrCategoryImmotype(lang, value) {
  var cat = getCategoryImmotype(lang, value);
  return "".concat(cat.category, "_").concat(cat.immotype);
};

exports.getStrCategoryImmotype = getStrCategoryImmotype;

function getImmotype(lang) {
  if (lang === undefined || lang === null) {
    return IMMOTYPE;
  } else {
    try {
      return IMMOTYPE[lang];
    } catch (error) {
      return {};
    }
  }
}

function getImmotypeLK(lang) {
  if (lang === undefined || lang === null) {
    return IMMOTYPELK;
  } else {
    try {
      return IMMOTYPELK[lang];
    } catch (error) {
      return {};
    }
  }
}

function getLicenseTypeGroups(lang) {
  if (lang === undefined || lang === null) {
    return BUSINESS;
  } else {
    try {
      return BUSINESS[lang];
    } catch (error) {
      return {};
    }
  }
}

function getImmotypeSlug() {
  var im_slugs = [];
  Object.keys(IMMOTYPE).map(function (lang) {
    Object.keys(IMMOTYPE[lang]).map(function (slug) {
      if (im_slugs.indexOf(slug) === -1) {
        im_slugs.push(slug);
      }
    });
  });
  return im_slugs;
}

function checkHomonymousRegion(value, level, firstGeo, geoType) {
  var homonymousRegions = Object.keys(_homonymousregions["default"]).filter(function (v) {
    return v === value;
  });

  if (homonymousRegions.length === 1 && level === 4) {
    var hrName = homonymousRegions[0];
    var hr = _homonymousregions["default"][hrName];
    var firstGeoKeys = Object.keys(firstGeo);

    if (firstGeoKeys.length > 0 && firstGeoKeys[0] === hr.level && firstGeo[hr.level].adm === hr.geo) {
      var el = hr.expectedLevel;
      geoType.dgeo = _defineProperty({}, el, {
        adm: hrName
      });
      geoType.geo.type = hr.exptectedType;
      return true;
    }
  }

  return false;
}

function decodeGeo(value) {
  REGEXP_REGIONS.lastIndex = 0;
  REGEXP_PROVINCE.lastIndex = 0;
  REGEXP_TURISM_ZONE.lastIndex = 0;
  var match_region = REGEXP_REGIONS.exec(value);
  var match_province = REGEXP_PROVINCE.exec(value);
  var match_turism_zone = REGEXP_TURISM_ZONE.exec(value);

  if (match_region) {
    return {
      type: GEO_TYPE_REGION,
      level1: match_region[0]
    };
  } else if (match_province) {
    return {
      type: GEO_TYPE_PROVINCE,
      level1: match_province[1]
    };
  } else if (match_turism_zone) {
    return {
      type: GEO_TYPE_AREAGROUP,
      geo_level_num: match_turism_zone[2],
      level1: match_turism_zone[3]
    };
  } else {
    return {
      type: GEO_TYPE_CITY,
      level1: value
    };
  }
}

function decodeGeoType(value, level) {
  var firstGeo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var geo = decodeGeo(value);
  var geoType = {
    geo: geo,
    dgeo: {},
    valid_levels: {}
  };

  switch (geo.type) {
    case GEO_TYPE_REGION:
      var isHomonymousRegion = checkHomonymousRegion(value, level, firstGeo, geoType);

      if (!isHomonymousRegion) {
        geoType.dgeo.l4 = {
          adm: geo.level1
        };
      }

      break;

    case GEO_TYPE_PROVINCE:
      geoType.dgeo.l6 = {
        adm: geo.level1
      };
      break;

    case GEO_TYPE_AREAGROUP:
      geoType.dgeo["l".concat(geo.geo_level_num)] = {
        areagroup: geo.level1
      };
      break;

    default:
      var town = geo.level1;
      var prov = '';
      REGEXP_HOMONYMOUS_TOWN.lastIndex = 0;
      var match_homonymous_town = REGEXP_HOMONYMOUS_TOWN.exec(town);

      if (match_homonymous_town && !_homonymousprovinces["default"].includes(match_homonymous_town[2])) {
        town = match_homonymous_town[1];
        prov = match_homonymous_town[2];
      }

      if (_homonymoustowns["default"][town]) {
        if (prov) {
          if (Object.keys(_homonymoustowns["default"][town]).map(function (p) {
            return p;
          }).includes(prov)) {
            var l6Type = prov.length === 2 ? 'short' : 'adm';
            geoType.dgeo.l6 = _defineProperty({}, l6Type, prov);
            geoType.dgeo.l9 = {
              adm: town
            };
          } else {
            geoType.dgeo.l9 = {
              adm: value
            };
            geoType.valid_levels["level".concat(level)] = false;
          }
        } else {
          geoType.dgeo.l9 = {
            adm: value
          };
          geoType.valid_levels["level".concat(level)] = false;
        }
      } else {
        if (prov) {
          geoType.dgeo.l9 = {
            adm: value
          };
        } else {
          geoType.dgeo.l9 = {
            adm: town
          };
        }
      }

      break;
  }

  return geoType;
}

function decodeAree(value) {
  var levelPrec = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var ZONE_TYPE = 'zone';
  var BLOCK_TYPE = 'block';
  var METROLINE_TYPE = 'metroline';
  var METROSTOP_TYPE = 'metrostop';
  REGEXP_METRO_LINE.lastIndex = 0;
  var match_metro_line = REGEXP_METRO_LINE.exec(value);

  if (match_metro_line) {
    return {
      type: METROLINE_TYPE,
      level1: match_metro_line[0]
    };
  }

  REGEXP_DEFAULT_AREA.lastIndex = 0;
  var match_default_area = REGEXP_DEFAULT_AREA.exec(value);

  if (match_default_area) {
    // level prec of a block is always a zone
    if (levelPrec === 'zone') {
      return {
        type: BLOCK_TYPE,
        level1: match_default_area[1]
      };
    }

    if (levelPrec === METROLINE_TYPE) {
      return {
        type: METROSTOP_TYPE,
        level1: match_default_area[1]
      };
    }

    return {
      type: ZONE_TYPE,
      level1: match_default_area[1]
    };
  } else {
    return {
      type: ZONE_TYPE,
      level1: value
    };
  }
}

function getBuildingConditions(lang, value) {
  REGEXP_BUILDING_CONDITIONS.lastIndex = 0;
  var match = REGEXP_BUILDING_CONDITIONS.exec(value);

  if (match) {
    return BUILDING_CONDITION_DECODE[lang][match[0]];
  }

  return undefined;
}

function getRooms(value) {
  REGEXP_ROOMS.lastIndex = 0;
  var match = REGEXP_ROOMS.exec(value);

  if (match) {
    return [match[1], true];
  } else {
    REGEXP_DROOMS.lastIndex = 0;
    var matchd = REGEXP_DROOMS.exec(value);

    if (matchd) {
      return [ROOMS_DECODE[matchd[1]], false];
    } else {
      return [undefined, undefined];
    }
  }
}

function getPrice(value) {
  var price = {
    da: 'from',
    finoa: 'to'
  };
  REGEXP_PRICEFULL.lastIndex = 0;
  var matchf = REGEXP_PRICEFULL.exec(value);

  if (matchf) {
    var _ref;

    return _ref = {}, _defineProperty(_ref, price[matchf[3]], matchf[4]), _defineProperty(_ref, price[matchf[5]], matchf[6]), _ref;
  } else {
    REGEXP_PRICE.lastIndex = 0;
    var match = REGEXP_PRICE.exec(value);

    if (match) {
      return _defineProperty({}, price[match[2]], match[3]);
    } else {
      return undefined;
    }
  }
}

function getFeatures(value) {
  REGEXP_FEATURES.lastIndex = 0;
  var matchf = REGEXP_FEATURES.exec(value);

  if (matchf) {
    return matchf[2].split(/-con-|-e-/gi);
  }

  return undefined;
}

function getPublisher(value) {
  REGEXP_PUBLISHER.lastIndex = 0;
  var match = REGEXP_PUBLISHER.exec(value);

  if (match) {
    return match[2];
  }
  /*
  REGEXP_PUBLISHERS.lastIndex = 0;
  const matchs = REGEXP_PUBLISHERS.exec(value);
  if (matchs) {
    return matchs[2].split(/\+|%2C|-|,/gi).map(p => PUBLISHER_LABELES.includes(p) ? p : null).filter(Boolean);
  }
  */


  return undefined;
}

function dumpImmotype(lang) {
  var immo = IMMOTYPE[lang];
  Object.keys(immo).map(function (cimmo) {
    if (cimmo != 'all') {
      var slug = immo[cimmo].slug;
      var str = "/".concat(slug, "/*");
      console.log(str);
    }
  });
}

function getImmotypeFromKey(key, lang) {
  var imt = getImmotype(lang);
  var found = false;
  var immo;
  Object.keys(imt).map(function (el) {
    if (!found) {
      var i_key = imt[el].key;

      if (i_key === key) {
        found = true;
        immo = imt[el];
      }
    }
  });
  return immo;
}

function getImmotypeSlugLangFromKey(key, lang) {
  var immo = getImmotypeFromKey(key, lang);
  return immo.slug;
}

function getChildrenImmotypeSlugFromKeys(category, ptype, lang) {
  var plural = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  var _ref3 = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {},
      _ref3$forceSrpUrl = _ref3.forceSrpUrl,
      forceSrpUrl = _ref3$forceSrpUrl === void 0 ? false : _ref3$forceSrpUrl;

  /**
   * TECH-4878 Set non SEO URL from locale-commerciale 
   * to negozio+locale+commerciale
   * meanwhile Leave locale-commerciale for SEO-URL.
   */

  /* TECH-7860 - TRASPASOS */
  // if (!forceSrpUrl && PTYPES_TO_ENCODE_DIFFERENTLY[ptype]) {
  //   ptype = PTYPES_TO_ENCODE_DIFFERENTLY[ptype];
  // }

  /* TECH-7860 - TRASPASOS */
  var immo = getChildrenImmotypeFromKeys(category, ptype, lang); // console.log(immo);

  return immo ? plural ? immo.slug_plural : immo.slug : null;
}

function getChildrenImmotypeFromKeys(category, ptype, lang) {
  var imt = getImmotype(lang);
  var imt_cat = imt[category] || imt[(0, _slugify.slugifyp)(category)]; // Add slugyp for category like box+cantine  

  if (imt && imt_cat) {
    var cat = imt_cat.children;
    var found = false;
    var immo = null;
    Object.keys(cat).map(function (el) {
      if (!found) {
        var i_keys = cat[el].keys;

        if (i_keys && i_keys.indexOf(ptype) > -1) {
          found = true;
          immo = cat[el];
        }

        var i_keysFor301 = cat[el].keysFor301;

        if (i_keysFor301 && i_keysFor301.indexOf(ptype) > -1) {
          found = true;
          immo = cat[el];
        }
      }
    });
    return immo;
  }

  return null;
}

function getSubImmotypeFromKey(key, lang) {
  var imt = getImmotype(lang);
  var found = false;
  var immo;
  Object.keys(imt).map(function (el) {
    if (!found) {
      if (imt[el].children) {
        Object.keys(imt[el].children).map(function (elc) {
          if (!found) {
            if (parseInt(key) === parseInt(imt[el].children[elc].key)) {
              found = true;
              immo = imt[el].children[elc];
            }
          }
        });
      }
    }
  });
  return immo;
}

function getSubImmotypeSlugLangFromKey(key, lang) {
  var immo = getSubImmotypeFromKey(key, lang);

  try {
    return immo.slug;
  } catch (error) {
    return '';
  }
}

function getLicenseTypeGroupFromKey(key) {
  var lang = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'it';
  var business;
  var businessList = getLicenseTypeGroups(lang);

  if (businessList) {
    Object.keys(businessList).map(function (businessEl) {
      var keys = businessList[businessEl].keys;

      if (keys && keys.indexOf(key) > -1) {
        business = businessList[businessEl];
      }
    });
  }

  return business;
}

function getLicenseTypeGroupSlugFromKey(key) {
  var lang = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'it';
  var plural = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var business;
  var businessList = getLicenseTypeGroups(lang);

  if (businessList) {
    Object.keys(businessList).map(function (businessEl) {
      var keys = businessList[businessEl].keys;
      var slug = plural ? businessList[businessEl].custom_slug || businessList[businessEl].slug_plural : businessList[businessEl].slug;

      if (keys && keys.indexOf(key) > -1 && slug) {
        business = slug;
      }
    });
  }

  return business;
}

function ptypesToImmotype(ptypes, lang) {
  var ret = {
    immotype: [],
    subimmotype: []
  };

  if (ptypes) {
    var a_ptypes = ptypes.split(',');
    a_ptypes.map(function (key) {
      if (Number.isInteger(parseInt(key))) {
        var fsimt = getSubImmotypeFromKey(key, lang);

        if (fsimt) {
          ret.subimmotype.push(fsimt);
        }
      } else {
        var fimt = getImmotypeFromKey(key, lang);

        if (fimt) {
          ret.immotype.push(fimt);
        }
      }
    });
  }

  return ret;
}

var isDictionary = function isDictionary(obj) {
  if (!obj) return false;
  if (Array.isArray(obj)) return false;
  if (obj.constructor != Object) return false;
  return true;
};

exports.isDictionary = isDictionary;

function getSeoDataFromJson(params) {
  var DECODED_SITES = {
    'athome.lu': 'athomelu',
    'athome.de': 'athomede',
    'immoregion.fr': 'immoregion'
  };
  var SEO_TYPE = ['title', 'description', 'h1', 'h2'];
  var seo_data = {};
  var value = {};
  Object.keys(params.seo_decode_type).map(function (el, idx) {
    var label = params.seo_decode_type[el];

    try {
      value = idx === 0 ? label === 'transaction' ? params.SEO_SRP_SPECS[label][params.tr] : params.SEO_SRP_SPECS[label] : value[label];
    } catch (e) {}
  });

  if (value) {
    if (Object.keys(value).indexOf('main') > -1) {
      value = value.main;
    } // console.log(c.bold(c.blue(JSON.stringify(value, null, 2))));


    SEO_TYPE.map(function (seotype) {
      // console.log(c.bold(c.red(seotype)));
      if (value) {
        var v_seotype = value[seotype];
        var t_meta;

        if (v_seotype) {
          var meta = v_seotype; // console.log(c.bold(c.green(JSON.stringify(meta, null, 2))));

          if (meta && meta.type) {
            meta.type.split('|').map(function (v) {
              if (meta) {
                switch (v) {
                  case 'd':
                    // domain
                    t_meta = meta[DECODED_SITES[params.domain]];
                    break;

                  case 'i':
                    // immotype
                    t_meta = meta[params.immotype];
                    break;

                  case 's':
                    // sub-immotype
                    t_meta = meta[params.immotype];
                    break;

                  case 'l':
                    // language
                    t_meta = meta[params.lang];
                    break;

                  default:
                    t_meta = meta[v];
                    break;
                }

                if (t_meta === '' || meta.all === '' || meta === '') {
                  t_meta = ' ';
                }

                meta = t_meta || meta.all || meta;
              }
            });
          } // seo_data[seotype] = eval('`' + meta + '`');


          if (meta !== undefined && meta != null) {
            seo_data[seotype] = meta;
          } // console.log(c.bold(c.blue(JSON.stringify(meta, null, 2))));

        }
      }
    });
  }

  return seo_data;
}

var convertFeaturesMyCasaToFilters = function convertFeaturesMyCasaToFilters(features) {
  var match;
  var qo = {};

  if (Array.isArray(features)) {
    features.map(function (feature) {
      switch (feature) {
        case 'giardino':
          qo.garden = ['comune', 'privato'];
          break;

        case String(feature.match(REGEXP_GARDEN_TYPE)):
          REGEXP_GARDEN_TYPE.lastIndex = 0;
          match = REGEXP_GARDEN_TYPE.exec(feature);
          qo.garden = match[1];
          break;

        case 'balcone':
          qo.balcony = true;
          break;

        case 'terrazzo':
          qo.terrace = true;
          break;

        case 'riscaldamento':
          qo.heatingType = ['autonomo', 'centralizzato'];
          break;

        case String(feature.match(REGEXP_HEATIG_TYPE)):
          REGEXP_HEATIG_TYPE.lastIndex = 0;
          match = REGEXP_HEATIG_TYPE.exec(feature);
          qo.heatingType = match[1];
          break;

        case 'foto':
          qo.photo = true;
          break;

        case String(feature.match(REGEXP_LIFT_LEVEL)):
          REGEXP_LIFT_LEVEL.lastIndex = 0;
          match = REGEXP_LIFT_LEVEL.exec(feature);
          qo.lift = match[1];
          break;

        case String(feature.match(REGEXP_BOX)):
          REGEXP_BOX.lastIndex = 0;
          match = REGEXP_BOX.exec(feature);
          qo.numParkingSpaces = 1;
          break;

        case String(feature.match(REGEXP_PUBLISHER_LEVEL)):
          REGEXP_PUBLISHER_LEVEL.lastIndex = 0;
          match = REGEXP_PUBLISHER_LEVEL.exec(feature);
          break;

        default:
          break;
      }
    });
  }

  return qo;
};

exports.convertFeaturesMyCasaToFilters = convertFeaturesMyCasaToFilters;

var checkParamsFromMyCasa = function checkParamsFromMyCasa(params) {
  params.channel = TR_DECODE_FOR_ESAPI[DEFAULT_LANG][params.channel];

  if (params.channel) {
    params.tr = params.channel;
  }

  if (params.locations && params.locations.length > 0) {
    delete params.q;
  }

  if (params.localities && !params.locations) {
    params.localities = params.localities.map(function (loc) {
      if (!loc.hkey) {
        loc.name = loc.alias;
        loc.type = 'freetext';

        if (loc.locationType === 'POSTAL_CODE') {
          loc.type = 'postalcode';
        }
      }

      return loc;
    });
    params.locations = params.localities;
    delete params.q;
  }

  if (params.propertyType && params.propertyType.length && !params.propertyTypes) {
    params.propertyTypes = params.propertyType;
  }

  if (params.exteriorFeatures) {
    var exteriorFeatures = convertFeaturesMyCasaToFilters(params.exteriorFeatures);
    params = _objectSpread({}, params, {}, exteriorFeatures);
  }

  if (params.interiorFeatures) {
    var interiorFeatures = convertFeaturesMyCasaToFilters(params.interiorFeatures);
    params = _objectSpread({}, params, {}, interiorFeatures);
  }

  if (params.agentCategory && params.agentCategory.length > 0 && params.agentCategory[0] !== 'all') {
    params.sellerType = params.agentCategory;
  }

  if (params.maxHouseSize) {
    params.mqMax = params.maxHouseSize;
  }

  if (params.minHouseSize) {
    params.mqMin = params.minHouseSize;
  }

  if (params.minPrice) {
    params.priceMin = params.minPrice;
  }

  if (params.maxPrice) {
    params.priceMax = params.maxPrice;
  }

  if (!params.onlyWithPhoto || params.onlyWithPhoto === "false") {
    delete params.onlyWithPhoto;
  }

  ;

  if (!params.includeSurrounding || params.includeSurrounding === "false") {
    delete params.includeSurrounding;
  }

  ;

  if (!params.surrounding || params.surrounding === "false") {
    delete params.surrounding;
  }

  ;
  delete params.channel;
  delete params.exteriorFeatures;
  delete params.interiorFeatures;
  delete params.preferredState;
  delete params.maxHouseSize;
  delete params.minHouseSize;
  delete params.minPrice;
  delete params.maxPrice;
  delete params.propertyType;
  delete params.agentCategory;
  delete params.localities;
  delete params.resolvedLocations;
  delete params.resolvedLocationCodes;
  delete params.resolvedSurroundingLocationCodes;
  delete params.searchUrl;
  delete params.serializedStr;
  delete params.domain;
  delete params.where;
  delete params.activeSort; // Delete useless paraemeters

  delete params.userId;
  delete params.searchType; // Delete parameters campaign

  delete params.gref;
  delete params.gclid;
  return params;
};

exports.checkParamsFromMyCasa = checkParamsFromMyCasa;

var createLHUrlBasedOnLevel = function createLHUrlBasedOnLevel(_ref4) {
  var slug = _ref4.slug,
      level = _ref4.level;
  var lhBaseUrlExplore = "".concat(_MiddlewareRedirectHelper.LH_BASE_URL, "lh/v2/explore/");

  switch (level) {
    case 4:
      return "".concat(lhBaseUrlExplore).concat(slug, ",").concat(level);

    case 6:
      return "".concat(lhBaseUrlExplore).concat(slug, ",").concat(level);

    case 9:
    case 10:
      return "".concat(lhBaseUrlExplore).concat(slug, ",9?size=200");

    case 11:
      return "".concat(lhBaseUrlExplore).concat(slug, ",9?levels=").concat(level, "&size=200");

    default:
      break;
  }
};

var getHashKeyFromLH = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee(_ref5) {
    var slug, level, slugLH, _short, urlLh, lhResponse, _ref7, _ref7$locations, locations, hashKey, _locations, loc, _ref8, _ref8$parent, province, region;

    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            slug = _ref5.slug, level = _ref5.level, slugLH = _ref5.slugLH, _short = _ref5["short"];
            urlLh = createLHUrlBasedOnLevel({
              slug: slugLH,
              level: level
            });
            _context.next = 4;
            return (0, _MiddlewareRedirectHelper.callApi)(urlLh, _MiddlewareRedirectHelper.HTTP_VERB_GET, null);

          case 4:
            lhResponse = _context.sent;
            _ref7 = lhResponse || {}, _ref7$locations = _ref7.locations, locations = _ref7$locations === void 0 ? [] : _ref7$locations;
            hashKey = null;

            if (!(locations.length > 0)) {
              _context.next = 22;
              break;
            }

            _locations = _slicedToArray(locations, 1), loc = _locations[0];
            _ref8 = loc || {}, _ref8$parent = _ref8.parent;
            _ref8$parent = _ref8$parent === void 0 ? {} : _ref8$parent;
            province = _ref8$parent.province, region = _ref8$parent.region;
            _context.t0 = level;
            _context.next = _context.t0 === 4 ? 15 : _context.t0 === 6 ? 17 : _context.t0 === 9 ? 19 : _context.t0 === 10 ? 19 : _context.t0 === 11 ? 19 : 21;
            break;

          case 15:
            if (region) {
              hashKey = region.hkey;
            }

            return _context.abrupt("break", 22);

          case 17:
            if (province) {
              hashKey = province.hkey;
            }

            return _context.abrupt("break", 22);

          case 19:
            locations.map(function (curr) {
              if (curr.slugs === slug && curr.level === level) {
                if (_short) {
                  var parent = curr.parent;
                  Object.keys(parent).map(function (key) {
                    if (parent[key]["short"] && parent[key]["short"] === _short) {
                      hashKey = curr.hkey;
                    }
                  });
                } else {
                  hashKey = curr.hkey;
                }
              }
            });
            return _context.abrupt("break", 22);

          case 21:
            return _context.abrupt("break", 22);

          case 22:
            return _context.abrupt("return", hashKey);

          case 23:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getHashKeyFromLH(_x) {
    return _ref6.apply(this, arguments);
  };
}();

var getSlugAndLevelForLH = function getSlugAndLevelForLH(_ref9) {
  var slug = _ref9.slug,
      level = _ref9.level,
      parent = _ref9.parent;

  if (!parent || Object.keys(parent).length === 0) {
    return {
      slugLH: slug,
      levelLH: level
    };
  }

  switch (level) {
    case 10:
    case 11:
      return {
        slugLH: parent.town.slug,
        levelLH: parent.town.level
      };

    default:
      return {
        slugLH: slug,
        levelLH: level
      };
  }
};

var getShortFromParent = function getShortFromParent() {
  var _ref10 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref10$parent = _ref10.parent,
      parent = _ref10$parent === void 0 ? {} : _ref10$parent;

  var _short2 = '';

  if (parent) {
    Object.keys(parent).map(function (key) {
      if (parent[key]["short"]) {
        _short2 = parent[key]["short"];
      }
    });
  }

  return _short2;
};

var getHashKeyFromSlugAndLevel = /*#__PURE__*/function () {
  var _ref12 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee2(_ref11) {
    var loc, slug, level, parent, _short3, _getSlugAndLevelForLH, slugLH, levelLH, hkey;

    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            loc = _ref11.loc;
            slug = loc.slug, level = loc.level, parent = loc.parent;
            _context2.prev = 2;

            if (!(slug && level)) {
              _context2.next = 10;
              break;
            }

            _short3 = getShortFromParent({
              parent: parent
            });
            _getSlugAndLevelForLH = getSlugAndLevelForLH({
              slug: slug,
              level: level,
              parent: parent
            }), slugLH = _getSlugAndLevelForLH.slugLH, levelLH = _getSlugAndLevelForLH.levelLH;
            _context2.next = 8;
            return getHashKeyFromLH({
              slug: slug,
              level: level,
              slugLH: slugLH,
              levelLH: levelLH,
              "short": _short3
            });

          case 8:
            hkey = _context2.sent;
            return _context2.abrupt("return", hkey);

          case 10:
            return _context2.abrupt("return", null);

          case 13:
            _context2.prev = 13;
            _context2.t0 = _context2["catch"](2);
            console.log('loc >>:', loc);
            console.log('Error getting hkey >>:', _context2.t0);
            return _context2.abrupt("return", null);

          case 18:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[2, 13]]);
  }));

  return function getHashKeyFromSlugAndLevel(_x2) {
    return _ref12.apply(this, arguments);
  };
}();

exports.getHashKeyFromSlugAndLevel = getHashKeyFromSlugAndLevel;